"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.TARGET_KEYWORDS = exports.TARGET_TYPES = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_sanofi/cssConstants.js"));

var _ErgoTopLevelView = _interopRequireDefault(require("./ErgoTopLevelView.scss"));

var _KESI2Helper = _interopRequireDefault(require("../../../../KESI2/KESI2Helper"));

var _Image = _interopRequireDefault(require("../../Image/Image"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _CordovaFileHelper = _interopRequireDefault(require("../../../../helpers/CordovaFileHelper"));

var _ArrayHelper = require("../../../../helpers/ArrayHelper");

var _ergoStrings = require("../../Strings/ergoStrings");

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _ErgoTargetChooser = _interopRequireWildcard(require("./ErgoTargetChooser"));

var _ErgoUnitsAdder = _interopRequireDefault(require("./ErgoUnitsAdder"));

var _DataStoreComponent2 = _interopRequireDefault(require("../../DataStoreComponent/DataStoreComponent2"));

var _data = require("./MockedData/data");

var _Constants = require("../../../constants/Constants");

var _UserManagementService = _interopRequireDefault(require("../../Equizzer/services/UserManagementService"));

var _MuiAlertHelper = require("../../../../helpers/MuiAlertHelper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var riskRingId = 'targetRing';
var IMAGE_ID = 'targetShield_background_image_';
var STATIC_IMAGE_ID = 'targetShield_static_background_image';
var TARGET_TYPES = {
  OTHER: 'userChosen',
  LEVEL: 'userLevel',
  ADD: 'addTarget'
};
exports.TARGET_TYPES = TARGET_TYPES;
var TARGET_KEYWORDS = {
  STRUCTURE: 'structure',
  MY_TARGETS: 'my_targets'
}; // mocked data assigned here because imports are read only

exports.TARGET_KEYWORDS = TARGET_KEYWORDS;
var currentTargets = _data.mockedTargets;

var TargetShield = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(TargetShield, _DataStoreComponent);

  var _super = _createSuper(TargetShield);

  function TargetShield(props) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, TargetShield);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setUserRank", function (event) {
      if (event && event.target) {
        _this.setState({
          userRank: event.target.value
        });
      }

      _this.updateRankDialogFn(true);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "saveUserRank", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var myData, newData, nextRank, nowDate;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              myData = _this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_USER_DATA];

              if (!(_this.state.userRank !== null && _this.state.userRank !== '')) {
                _context.next = 8;
                break;
              }

              myData.rank = _this.state.userRank;
              newData = {};

              if (_this.state.userRank > 0) {
                nextRank = _this.getNextRankForUser(_this.state.userRank);
                nextRank.contracts = [];
                nowDate = new Date();
                nowDate.setHours(0, 0, 0, 0);
                nextRank.startTime = nowDate.getTime();
                newData[_DataStore.DATA_STORE_PATHS.ERGO_USER_TARGETS] = [nextRank];
              }

              newData[_DataStore.DATA_STORE_PATHS.ERGO_USER_DATA] = myData;
              _context.next = 8;
              return _DataStore["default"].setData(newData);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getNextRankForUser", function (rank) {
      var nextRank = _data.mockedPositions.find(function (position) {
        return position.level === rank + 1;
      });

      if (nextRank) {
        return nextRank;
      } else {
        return _data.mockedPositions.reduce(function (prev, current) {
          return prev.level > current.level ? prev : current;
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateUserData", function (index) {
      var user = _this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_USER_DATA];
      var targets = _this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_USER_TARGETS];
      var target = targets[index];

      var unitsForTarget = _this.getSummedUnitsForTarget(target);

      var maxLevel = _data.mockedPositions.reduce(function (prev, current) {
        return prev.level > current.level ? prev : current;
      });

      maxLevel = maxLevel ? maxLevel.level : 1;
      var shouldLevelUpCounter = 0;

      if (user.level < maxLevel) {
        target.conditions.forEach(function (condition) {
          if (condition.type === _ErgoTargetChooser.STRUCTURE_TARGET_TYPES.OWN) {
            if (unitsForTarget >= condition.value) {
              shouldLevelUpCounter++;
            }
          } else if (condition.type === _ErgoTargetChooser.STRUCTURE_TARGET_TYPES.OTHERS) {
            if ((_this.state.structureUnits || 0) > condition.value) {
              shouldLevelUpCounter++;
            }
          }
        });
      }

      if (shouldLevelUpCounter === target.conditions.length) {
        var newData = {};
        user.level += 1;

        var nextLevel = _this.getNextLevelForUser(user.level);

        nextLevel.contracts = [];
        nextLevel.startTime = (0, _now["default"])();
        targets[index] = nextLevel;
        newData[_DataStore.DATA_STORE_PATHS.ERGO_USER_TARGETS] = targets;
        newData[_DataStore.DATA_STORE_PATHS.ERGO_USER_DATA] = user;

        _DataStore["default"].setData(newData);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getStructureData", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var structureData, newData, myData, summedUnits, getUnits;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_ACTIVATED] === true)) {
                _context2.next = 14;
                break;
              }

              _context2.next = 3;
              return _UserManagementService["default"].getStructureData();

            case 3:
              structureData = _context2.sent;
              newData = {};
              myData = _this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_USER_DATA];
              summedUnits = [];

              getUnits = function getUnits(user) {
                if (user.pnr !== myData.pnr) {
                  user.structureUnits.forEach(function (unitObj) {
                    summedUnits.push(unitObj);
                  });
                }

                user.subs.forEach(function (subUser) {
                  getUnits(subUser);
                });
              };

              getUnits(structureData.user);
              newData[_DataStore.DATA_STORE_PATHS.ERGO_SUMMED_STRUCTURE_UNITS] = summedUnits;
              newData[_DataStore.DATA_STORE_PATHS.ERGO_STRUCTURE_DATA] = structureData;
              _context2.next = 13;
              return _DataStore["default"].setData(newData);

            case 13:
              _this.getSummedStructureUnitsForCurrentMonth();

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setRingWidths", function () {
      var shouldUpdate = false;
      var widths = currentTargets.map(function (target, index) {
        var riskRing = document.getElementById("".concat(riskRingId).concat(index));

        if (!riskRing) {
          return 0;
        } else if (riskRing && _this.state.widths[index] !== riskRing.offsetHeight) {
          shouldUpdate = true;
          return riskRing.offsetHeight;
        } else {
          return riskRing.offsetHeight;
        }
      });

      if (shouldUpdate) {
        _this.setState({
          widths: widths
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "addUnits", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(contract) {
        var _targets, _target;

        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                if (!(_this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_USER_TARGETS] && _this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_USER_TARGETS][_this.state.targetIndex])) {
                  _context3.next = 7;
                  break;
                }

                _targets = (0, _toConsumableArray2["default"])(_this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_USER_TARGETS]);
                _target = _targets[_this.state.targetIndex];

                _target.contracts.push(contract);

                _context3.next = 7;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.ERGO_USER_TARGETS, _targets);

              case 7:
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);
                console.error("Error adding units amount: ".concat(units, " in targetShield"), _context3.t0);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 9]]);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "resetUnits", /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(contracts) {
        var _targets2, targetContracts;

        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                if (!(_this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_USER_TARGETS] && _this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_USER_TARGETS][_this.state.targetIndex])) {
                  _context4.next = 7;
                  break;
                }

                _targets2 = _this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_USER_TARGETS];
                targetContracts = _targets2[_this.state.targetIndex].contracts;
                contracts.forEach(function (contract) {
                  var index = targetContracts.findIndex(function (targetContract) {
                    return targetContract.id === contract.id;
                  });

                  if (index > -1) {
                    targetContracts.splice(index, 1);
                  }
                });
                _context4.next = 7;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.ERGO_USER_TARGETS, _targets2);

              case 7:
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](0);
                console.error("Error removing target ".concat(targets, " in targetShield"), _context4.t0);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 9]]);
      }));

      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "removeTarget", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(target) {
        var targetType, newTargets;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                targetType = _this.props.keyword === TARGET_KEYWORDS.MY_TARGETS ? _DataStore.DATA_STORE_PATHS.ERGO_USER_TARGETS : _DataStore.DATA_STORE_PATHS.ERGO_STRUCTURE_TARGETS;
                newTargets = (0, _ArrayHelper.removeElementFromCopy)(_this.state.data[targetType], target);
                _context5.next = 5;
                return _DataStore["default"].setSingleData(targetType, newTargets);

              case 5:
                _context5.next = 10;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);
                console.error("Error removing target ".concat(target, " in targetShield"), _context5.t0);

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 7]]);
      }));

      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "addTarget", /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(target) {
        var oldTargets, newTargets, _newTargets;

        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                if (!(_this.props.keyword === TARGET_KEYWORDS.MY_TARGETS)) {
                  _context6.next = 8;
                  break;
                }

                oldTargets = _this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_USER_TARGETS] || [];
                newTargets = oldTargets.concat([target]);
                _context6.next = 6;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.ERGO_USER_TARGETS, newTargets);

              case 6:
                _context6.next = 11;
                break;

              case 8:
                // only one monthly target possible
                _newTargets = [target];
                _context6.next = 11;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.ERGO_STRUCTURE_TARGETS, _newTargets);

              case 11:
                _context6.next = 16;
                break;

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6["catch"](0);
                console.error("Error adding new target ".concat(target, " in targetShield"), _context6.t0);

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 13]]);
      }));

      return function (_x4) {
        return _ref6.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getTargets", function () {
      var targetType = _this.props.keyword === TARGET_KEYWORDS.MY_TARGETS ? _DataStore.DATA_STORE_PATHS.ERGO_USER_TARGETS : _DataStore.DATA_STORE_PATHS.ERGO_STRUCTURE_TARGETS;
      var currentTargets;

      if (_this.state.data[targetType]) {
        currentTargets = (0, _toConsumableArray2["default"])(_this.state.data[targetType]);
      } else {
        currentTargets = [];
      }

      var date = new Date();

      if (_this.props.keyword === TARGET_KEYWORDS.STRUCTURE && (currentTargets.length === 0 || date.getMonth() > currentTargets[0].month)) {
        currentTargets = [{
          type: TARGET_TYPES.ADD,
          conditions: [{
            description: '',
            value: 0,
            time: 0
          }]
        }];
      }

      if (_this.props.keyword === TARGET_KEYWORDS.MY_TARGETS) {
        if (currentTargets.length === 0 || currentTargets.length < 4 && (0, _ArrayHelper.getLastElement)(currentTargets).type !== TARGET_TYPES.ADD) {
          currentTargets.push({
            type: TARGET_TYPES.ADD,
            conditions: [{
              description: '',
              value: 0,
              time: 0
            }]
          });
        }
      }

      return currentTargets;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getNextLevelForUser", function (level) {
      var nextLevel = _data.mockedPositions.find(function (position) {
        return position.level === level + 1;
      });

      if (nextLevel) {
        return nextLevel;
      } else {
        return _data.mockedPositions.reduce(function (prev, current) {
          return prev.level > current.level ? prev : current;
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeIndex", function (currentIndex) {
      _this.isRunning = true;

      _this.setState({
        targetIndex: currentIndex,
        unitsCount: [0, 0],
        timeCount: [0, 0]
      });

      var images = (0, _toConsumableArray2["default"])(document.getElementsByClassName(_ErgoTopLevelView["default"].imageContainer));
      images.forEach(function (image, index) {
        image.classList.remove(_ErgoTopLevelView["default"].imageContainerNoTrans);

        if (index === _this.state.targetIndex) {
          image.style.opacity = 1;
        } else {
          image.style.opacity = 0;
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSwitching", function (index) {
      _this.setState({
        donutVisible: false
      });

      var currentIndex = _this.state.targetIndex;
      var newIndex = null;

      if (index > currentIndex) {
        newIndex = currentIndex + 1;
      } else if (index < currentIndex) {
        newIndex = currentIndex - 1;
      } else {
        _this.setState({
          donutVisible: true
        });

        var images = (0, _toConsumableArray2["default"])(document.getElementsByClassName(_ErgoTopLevelView["default"].imageContainer));
        images.forEach(function (image, imgIndex) {
          image.classList.remove(_ErgoTopLevelView["default"].imageContainerNoTrans);

          if (imgIndex === currentIndex) {
            image.style.opacity = 1;
          } else {
            image.style.opacity = 0;
          }
        });
      }

      var image = document.getElementById("".concat(IMAGE_ID).concat(currentIndex));

      if (image) {
        image.classList.add(_ErgoTopLevelView["default"].imageContainerNoTrans);

        if (index !== currentIndex) {
          image.style.opacity = 1 - Math.abs(index - currentIndex) * 2;
        }
      }

      var newImage = document.getElementById("".concat(IMAGE_ID).concat(newIndex));

      if (newImage) {
        newImage.classList.add(_ErgoTopLevelView["default"].imageContainerNoTrans);

        if (index !== currentIndex) {
          newImage.style.opacity = Math.abs(index - currentIndex) * 2;
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onTransitionEnd", function (target) {
      _this.setState({
        donutVisible: true
      });

      clearInterval(_this.countingTimer);
      _this.isRunning = false;

      _this.startCountingAnimation(20, 1000, target);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getStyles", function (index) {
      var ringStyle = {};
      var addStyle = {};
      var arrowStyle = {};
      var ringTranslateX = _DeviceInfoHelper["default"].isAndroid() ? 95 : 85;

      if (_this.state.targetIndex === index) {
        ringStyle = {
          transform: 'translate3d(0, 0, 0)',
          width: _this.state.widths[index]
        };
        addStyle = {
          transform: 'translate3d(-50%, -50%, 0)'
        };
        arrowStyle = {
          transform: 'translate3d(-50%, -50%, 0)',
          opacity: 0,
          transition: 'transform 1000ms, opacity 500ms'
        };
      } else if (_this.state.targetIndex > index) {
        ringStyle = {
          transform: "translate3d(".concat(ringTranslateX, "%, 0, 0)"),
          width: _this.state.widths[index]
        };
        addStyle = {
          transform: 'translate3d(30%, -50%, 0)'
        };
        arrowStyle = {
          transform: 'translate3d(30%, -50%, 0)',
          opacity: 1,
          transition: 'transform 1000ms, opacity 500ms 500ms'
        };
      } else {
        ringStyle = {
          transform: "translate3d(-".concat(ringTranslateX, "%, 0, 0)"),
          width: _this.state.widths[index]
        };
        addStyle = {
          transform: 'translate3d(-130%, -50%, 0)'
        };
        arrowStyle = {
          transform: 'translate3d(-130%, -50%, 0)',
          opacity: 1,
          transition: 'transform 1000ms, opacity 500ms 500ms'
        };
      }

      return {
        ringStyle: ringStyle,
        addStyle: addStyle,
        arrowStyle: arrowStyle
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "increaseCounts", function (tick, target) {
      var conditions = target.conditions;
      var timeCount = (0, _toConsumableArray2["default"])(_this.state.timeCount);
      var unitsCount = (0, _toConsumableArray2["default"])(_this.state.unitsCount);
      var currentUnits;
      currentUnits = _this.props.keyword === TARGET_KEYWORDS.MY_TARGETS ? _this.getSummedUnitsForTarget(target) : _this.getMonthlyUnitSum();
      var doneCounter = 0;

      for (var i = 0; i < conditions.length; i++) {
        if (conditions[i].type && conditions[i].type === _ErgoTargetChooser.STRUCTURE_TARGET_TYPES.OTHERS) {
          currentUnits = _this.props.keyword === TARGET_KEYWORDS.MY_TARGETS ? _this.getSummedStructureUnitsForTarget(target) : _this.state.structureUnits || 0;
        } else if (_this.props.keyword === TARGET_KEYWORDS.MY_TARGETS && conditions[i].type && conditions[i].type === _ErgoTargetChooser.STRUCTURE_TARGET_TYPES.BOTH) {
          currentUnits += _this.getSummedStructureUnitsForTarget(target);
        }

        var currentTime = _this.props.keyword === TARGET_KEYWORDS.STRUCTURE ? new Date().getDate() : target.startTime ? Math.round(((0, _now["default"])() - target.startTime) / (1000 * 3600 * 24)) : 0;
        var tickTime = currentTime / tick;
        var tickUnits = currentUnits / tick;

        if (_this.state.timeCount[i] + tickTime >= currentTime && _this.state.unitsCount[i] + tickUnits >= currentUnits) {
          doneCounter++;

          if (doneCounter === conditions.length) {
            _this.isRunning = false;
            clearInterval(_this.countingTimer);

            _this.setState({
              timeCount: [0, 0],
              unitsCount: [0, 0]
            });

            return;
          }

          continue;
        }

        timeCount[i] += tickTime;
        unitsCount[i] += tickUnits;
        timeCount[i] = Math.round(timeCount[i] * 100) / 100;
        unitsCount[i] = Math.round(unitsCount[i] * 100) / 100;
      }

      _this.setState({
        timeCount: timeCount,
        unitsCount: unitsCount
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "startCountingAnimation", function (ticks, duration, target) {
      if (!_this.isRunning && target.type !== TARGET_TYPES.ADD) {
        _this.isRunning = true;
        _this.countingTimer = setInterval(function () {
          return _this.increaseCounts(ticks, target);
        }, duration / ticks);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderSingleTarget", function (target, condition, index, index2, currentUnits, currentTime, hasTime) {
      var style = _this.getStyles(index);

      if (target.type === TARGET_TYPES.ADD) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          onClick: _this.showAddTargetDialog,
          className: "".concat(_this.state.targetIndex === index ? _ErgoTopLevelView["default"].textAnimation : '')
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _ErgoTopLevelView["default"].addInfo,
          style: style.addStyle
        }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
          alt: "add icon",
          className: _ErgoTopLevelView["default"].addIcon,
          src: require('../assets/addIconErgo.svg')
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: _ErgoTopLevelView["default"].addText
        }, _this.props.keyword === TARGET_KEYWORDS.STRUCTURE ? (0, _ergoStrings.getString)('ENTER_MONTHLY_TARGET') : (0, _ergoStrings.getString)('ENTER_TARGET'), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
          name: "chevron-right"
        })));
      } else {
        var isSmallDevice = window.innerWidth < _Constants.SMALL_TEXT_DEVICE_WIDTH;
        return /*#__PURE__*/_react["default"].createElement("div", null, style.arrowStyle.opacity === 1 && /*#__PURE__*/_react["default"].createElement("div", {
          className: _ErgoTopLevelView["default"].arrowContainer,
          style: style.arrowStyle,
          onClick: function onClick() {
            _this.setState({
              targetIndex: index
            });
          }
        }, _this.state.targetIndex > index ? /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
          className: _ErgoTopLevelView["default"].arrow,
          name: "chevron-left"
        }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
          className: _ErgoTopLevelView["default"].arrow,
          name: "chevron-right"
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(_this.state.targetIndex === index ? _ErgoTopLevelView["default"].textAnimation : '')
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            lineHeight: hasTime ? '1' : 'normal'
          },
          className: "".concat(isSmallDevice ? _ErgoTopLevelView["default"].targetInformationSmall : _ErgoTopLevelView["default"].targetInformation)
        }, condition.time && [/*#__PURE__*/_react["default"].createElement("span", {
          className: isSmallDevice ? _ErgoTopLevelView["default"].circleTimeNumberSmall : _ErgoTopLevelView["default"].circleTimeNumber
        }, "".concat(_this.isRunning ? _this.state.timeCount[index2] : currentTime, " / ").concat(condition.time), /*#__PURE__*/_react["default"].createElement("br", null)), /*#__PURE__*/_react["default"].createElement("span", {
          className: isSmallDevice ? _ErgoTopLevelView["default"].circleTimeTextSmall : _ErgoTopLevelView["default"].circleTimeText
        }, "Tage", /*#__PURE__*/_react["default"].createElement("br", null))], /*#__PURE__*/_react["default"].createElement("span", {
          className: isSmallDevice ? _ErgoTopLevelView["default"].circleUnitsNumberSmall : _ErgoTopLevelView["default"].circleUnitsNumber
        }, "".concat(_this.isRunning ? _this.state.unitsCount[index2] : currentUnits, " / ").concat(condition.value), /*#__PURE__*/_react["default"].createElement("br", null)), /*#__PURE__*/_react["default"].createElement("span", {
          className: isSmallDevice ? _ErgoTopLevelView["default"].circleUnitsTextSmall : _ErgoTopLevelView["default"].circleUnitsText
        }, "Einheiten")), _this.props.keyword === TARGET_KEYWORDS.MY_TARGETS && (condition.type === _ErgoTargetChooser.STRUCTURE_TARGET_TYPES.OWN || condition.type === _ErgoTargetChooser.STRUCTURE_TARGET_TYPES.BOTH) && /*#__PURE__*/_react["default"].createElement("div", {
          onClick: _this.showAddUnitsDialog
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(isSmallDevice ? _ErgoTopLevelView["default"].addUnitsSmall : _ErgoTopLevelView["default"].addUnits),
          style: style.addStyle
        }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
          alt: "add icon",
          className: _ErgoTopLevelView["default"].addIcon,
          src: require('../assets/addIconErgo.svg')
        }))), _this.props.keyword === TARGET_KEYWORDS.STRUCTURE && /*#__PURE__*/_react["default"].createElement("div", {
          onClick: _this.showAddTargetDialog,
          className: hasTime ? _ErgoTopLevelView["default"].addUnitsWithTime : _ErgoTopLevelView["default"].addUnits,
          style: style.addStyle
        }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
          className: _ErgoTopLevelView["default"].addIcon,
          name: 'refresh'
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: _ErgoTopLevelView["default"].secureProfile
        })));
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getMonthlyUnitSum", function () {
      var sum = 0;
      var units = _this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_STRUCTURE_UNITS] || [];
      var date = new Date();
      var currentMonth = (date.getMonth() + 1).toString();
      var currentYear = date.getFullYear().toString();

      if (currentMonth.length < 2) {
        currentMonth = "0".concat(currentMonth);
      }

      units.forEach(function (unitObj) {
        var dateArray = unitObj.date.split('-');
        var unitMonth = dateArray[1];
        var unitYear = dateArray[0];

        if (currentMonth === unitMonth && unitYear === currentYear) {
          sum += unitObj.units;
        }
      });
      sum = Math.round(sum * 100) / 100;
      return sum;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getSummedStructureUnitsForTarget", function (target) {
      var sum = 0;
      var units = _this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_SUMMED_STRUCTURE_UNITS] || [];
      units.forEach(function (unitObj) {
        var dateArray = unitObj.date.split('-');
        var unitTime = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]).getTime();
        var maxUnits = target.value * target.structureUnitFactor;

        if (unitTime >= target.startTime) {
          sum += Math.min(unitObj.units, maxUnits);
        }
      });
      sum = Math.round(sum * 100) / 100;
      return sum;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getSummedStructureUnitsForCurrentMonth", function () {
      var sum = 0;
      var units = _this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_SUMMED_STRUCTURE_UNITS] || [];
      var date = new Date();
      var currentMonth = (date.getMonth() + 1).toString();
      var currentYear = date.getFullYear().toString();

      if (currentMonth.length < 2) {
        currentMonth = "0".concat(currentMonth);
      }

      units.forEach(function (unitObj) {
        var dateArray = unitObj.date.split('-');
        var month = dateArray[1];
        var unitYear = dateArray[0];

        if (month === currentMonth && unitYear === currentYear) {
          sum += unitObj.units;
        }
      });
      sum = Math.round(sum * 100) / 100;

      _this.setState({
        structureUnits: sum
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getSummedUnitsForTarget", function (target) {
      var sum = 0;

      if (target && target.contracts) {
        target.contracts.forEach(function (contract) {
          sum += contract.units;
        });
        sum = Math.round(sum * 100) / 100;
      }

      return sum;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderTarget", function (content, currentTargets) {
      if (currentTargets.length === 0) {
        return null;
      }

      if (content.background) {
        return null;
      }

      var myStructureUnitSum = _this.getMonthlyUnitSum();

      var targets = currentTargets.map(function (target, index) {
        var currentUnits;

        if (target.type === TARGET_TYPES.OTHER || target.type === TARGET_TYPES.LEVEL) {
          currentUnits = _this.props.keyword === TARGET_KEYWORDS.MY_TARGETS ? _this.getSummedUnitsForTarget(target) : myStructureUnitSum;
        }

        var elements = target.conditions.map(function (condition, index2) {
          // on invidivual target we count all SummedStructureUnits since startTime // on structure target we only count since beginning of month
          if (condition.type && condition.type === _ErgoTargetChooser.STRUCTURE_TARGET_TYPES.OTHERS) {
            currentUnits = _this.props.keyword === TARGET_KEYWORDS.MY_TARGETS ? _this.getSummedStructureUnitsForTarget(target) : _this.state.structureUnits || 0;
          } else if (_this.props.keyword === TARGET_KEYWORDS.MY_TARGETS && condition.type && condition.type === _ErgoTargetChooser.STRUCTURE_TARGET_TYPES.BOTH) {
            currentUnits += _this.getSummedStructureUnitsForTarget(target);
          }

          var percentUnits;
          var percentTime;
          var currentTime;

          if (target.type === TARGET_TYPES.ADD) {
            percentUnits = 0;
            percentTime = 0;
            currentTime = 0;
          } else {
            currentTime = _this.props.keyword === TARGET_KEYWORDS.STRUCTURE ? new Date().getDate() : target.startTime ? Math.round(((0, _now["default"])() - target.startTime) / (1000 * 3600 * 24)) : 0;
            percentUnits = currentUnits > condition.value ? 1 : currentUnits / condition.value;
            percentTime = currentTime > condition.time ? 1 : currentTime / condition.time;
          }

          currentUnits = Math.round(currentUnits * 100) / 100;
          var hasTime = condition.time ? true : false;
          var unitsCircleRadius = hasTime ? 12.91549430918954 : 15.91549430918954;
          var timeCircleRadius = 15.91549430918954;
          var strokeDashArrayLengthUnits = hasTime ? 81.15 : 100;
          var strokeDashArrayLengthTime = 100;
          var strokeDashArrayPercentUnits = _this.state.targetIndex === index ? percentUnits * strokeDashArrayLengthUnits : 0;
          var strokeDashArrayPercentTime = _this.state.targetIndex === index ? percentTime * strokeDashArrayLengthTime : 0;

          var style = _this.getStyles(index);

          if (target.conditions.length === 1) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                height: '100%'
              },
              key: "target_".concat(index).concat(index2)
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: _ErgoTopLevelView["default"].targetDescription,
              style: {
                paddingBottom: '15px',
                position: 'relative'
              }
            }, condition.description), /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                height: '70%',
                position: 'relative'
              }
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: _ErgoTopLevelView["default"].itemCss,
              style: {
                width: _this.state.widths[index] - 2,
                height: "".concat((_this.state.widths[index] - 2) / _this.state.widths[index] * 100, "%")
              },
              key: "svgKey".concat(percentUnits)
            }, /*#__PURE__*/_react["default"].createElement("svg", {
              className: _ErgoTopLevelView["default"].svg,
              viewBox: "-17 -17 34 34",
              key: "target_".concat(index).concat(index2)
            }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("circle", {
              r: unitsCircleRadius,
              cy: 0,
              cx: 0,
              fill: '#C61A2D'
            }), /*#__PURE__*/_react["default"].createElement("circle", {
              r: unitsCircleRadius,
              cy: 0,
              cx: 0,
              strokeWidth: '3',
              stroke: '#c63a49',
              fill: 'none'
            }), /*#__PURE__*/_react["default"].createElement("circle", {
              id: "unitCircle",
              className: _this.state.targetIndex === index ? _ErgoTopLevelView["default"].circleAnimation : '',
              r: unitsCircleRadius,
              cy: 0,
              cx: 0,
              strokeWidth: '3',
              strokeDasharray: "".concat(strokeDashArrayPercentUnits, " ").concat(strokeDashArrayLengthUnits),
              stroke: '#ffffff',
              fill: 'none'
            })))), hasTime && /*#__PURE__*/_react["default"].createElement("div", {
              className: _ErgoTopLevelView["default"].itemCss,
              style: {
                width: _this.state.widths[index],
                height: '100%'
              }
            }, /*#__PURE__*/_react["default"].createElement("svg", {
              className: _ErgoTopLevelView["default"].svg,
              viewBox: "-17 -17 34 34"
            }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("circle", {
              style: {
                opacity: '0.5'
              },
              r: timeCircleRadius,
              cy: 0,
              cx: 0,
              strokeWidth: '3',
              stroke: '#a1101f',
              fill: 'none'
            }), /*#__PURE__*/_react["default"].createElement("circle", {
              id: "timeCircle",
              className: _this.state.targetIndex === index ? _ErgoTopLevelView["default"].circleAnimation : '',
              r: timeCircleRadius,
              cy: 0,
              cx: 0,
              strokeWidth: '3',
              stroke: '#761012',
              fill: 'none',
              strokeDasharray: "".concat(strokeDashArrayPercentTime, " ").concat(strokeDashArrayLengthTime)
            })))), /*#__PURE__*/_react["default"].createElement("div", {
              id: "".concat(riskRingId).concat(index),
              className: _ErgoTopLevelView["default"].riskRingBackground,
              style: style.ringStyle
            }), /*#__PURE__*/_react["default"].createElement("div", {
              className: _ErgoTopLevelView["default"].riskRing,
              style: style.ringStyle
            }, _this.renderSingleTarget(target, condition, index, index2, currentUnits, currentTime, hasTime))));
          } else if (target.conditions.length === 2) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                height: '100%',
                width: '50%',
                "float": "".concat(index2 === 0 ? 'left' : 'right')
              },
              key: "target_".concat(index).concat(index2)
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: _ErgoTopLevelView["default"].targetDescription,
              style: {
                paddingBottom: '20px',
                position: 'relative'
              }
            }, condition.description), /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                height: '60%',
                position: 'relative'
              }
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: _ErgoTopLevelView["default"].itemCss,
              style: {
                width: _this.state.widths[index] - 2,
                height: "".concat((_this.state.widths[index] - 2) / _this.state.widths[index] * 100, "%")
              },
              key: "svgKey".concat(percentUnits)
            }, /*#__PURE__*/_react["default"].createElement("svg", {
              className: _ErgoTopLevelView["default"].svg,
              viewBox: "-17 -17 34 34"
            }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("circle", {
              r: unitsCircleRadius,
              cy: 0,
              cx: 0,
              fill: '#C61A2D'
            }), /*#__PURE__*/_react["default"].createElement("circle", {
              className: '',
              r: unitsCircleRadius,
              cy: 0,
              cx: 0,
              strokeWidth: '3',
              stroke: '#c63a49',
              fill: 'none'
            }), /*#__PURE__*/_react["default"].createElement("circle", {
              id: "unitCircle",
              className: _this.state.targetIndex === index ? _ErgoTopLevelView["default"].circleAnimation : '',
              r: unitsCircleRadius,
              cy: 0,
              cx: 0,
              strokeWidth: '3',
              strokeDasharray: "".concat(strokeDashArrayPercentUnits, " ").concat(strokeDashArrayLengthUnits),
              stroke: '#ffffff',
              fill: 'none'
            })))), hasTime && /*#__PURE__*/_react["default"].createElement("div", {
              className: _ErgoTopLevelView["default"].itemCss,
              style: {
                width: _this.state.widths[index],
                height: '100%'
              }
            }, /*#__PURE__*/_react["default"].createElement("svg", {
              className: _ErgoTopLevelView["default"].svg,
              viewBox: "-17 -17 34 34"
            }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("circle", {
              style: {
                opacity: '0.33'
              },
              r: timeCircleRadius,
              cy: 0,
              cx: 0,
              strokeWidth: '3',
              stroke: '#a1101f',
              fill: 'none'
            }), /*#__PURE__*/_react["default"].createElement("circle", {
              id: "timeCircle",
              className: _this.state.targetIndex === index ? _ErgoTopLevelView["default"].circleAnimation : '',
              r: timeCircleRadius,
              cy: 0,
              cx: 0,
              strokeWidth: '3',
              stroke: '#761012',
              fill: 'none',
              strokeDasharray: "".concat(strokeDashArrayPercentTime, " ").concat(strokeDashArrayLengthTime)
            })))), /*#__PURE__*/_react["default"].createElement("div", {
              id: "".concat(riskRingId).concat(index),
              className: _ErgoTopLevelView["default"].riskRingBackground,
              style: style.ringStyle
            }), /*#__PURE__*/_react["default"].createElement("div", {
              className: _ErgoTopLevelView["default"].riskRing,
              style: style.ringStyle
            }, _this.renderSingleTarget(target, condition, index, index2, currentUnits, currentTime, hasTime))));
          } else {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: "target_".concat(index).concat(index2)
            }, "Not yet implemented");
          }
        });
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            opacity: "".concat(_this.state.targetIndex === index ? 100 : 0),
            height: '100%'
          },
          key: "target_".concat(index)
        }, elements);
      });
      return targets;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showAddTargetDialog", function () {
      _this.setState({
        showAddTargetDialog: !_this.state.showAddTargetDialog
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showAddUnitsDialog", function () {
      _this.setState({
        showAddUnitsDialog: !_this.state.showAddUnitsDialog
      });
    });
    _this.state = {
      widths: [],
      images: [],
      filePath: _DeviceInfoHelper["default"].isBrowser() ? null : _CordovaFileHelper["default"].getDataFolder(),
      showAddTargetDialog: false,
      showAddUnitsDialog: false,
      targetIndex: 0,
      currentTime: 0,
      timeCount: [0, 0],
      unitsCount: [0, 0],
      donutVisible: true,
      structureUnits: 0,
      structureUnitsForLevel: 0,
      targetContracts: [],
      userRank: ''
    };
    _this.updateRankDialogFn = null;
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(TargetShield.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.ERGO_SUMMED_STRUCTURE_UNITS, _DataStore.DATA_STORE_PATHS.ERGO_USER_DATA, _DataStore.DATA_STORE_PATHS.ERGO_USER_TARGETS, _DataStore.DATA_STORE_PATHS.ERGO_STRUCTURE_UNITS, _DataStore.DATA_STORE_PATHS.ERGO_STRUCTURE_TARGETS, _DataStore.DATA_STORE_PATHS.ERGO_ACTIVATED]);
    _this.isRunning = false;
    return _this;
  }

  (0, _createClass2["default"])(TargetShield, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
        var _this2 = this;

        var targets, okButton, levelTarget, sum;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.setRingWidths();
                this.getStructureData();
                targets = this.getTargets();
                console.log('targets', targets);

                if (targets.length > 0) {
                  setTimeout(function () {
                    return _this2.startCountingAnimation(10, 1000, targets[0], 500);
                  });
                }

                if (this.props.keyword === TARGET_KEYWORDS.MY_TARGETS) {
                  if (this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_USER_DATA] && !('rank' in this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_USER_DATA])) {
                    okButton = {
                      label: (0, _ergoStrings.getString)('OK'),
                      callback: function callback() {
                        _this2.saveUserRank();
                      }
                    };
                    this.updateRankDialogFn = (0, _MuiAlertHelper.showWideAlertReact)( /*#__PURE__*/_react["default"].createElement("div", null, (0, _ergoStrings.getString)('CHOOSE_USER_LEVEL')), null, (0, _ergoStrings.getString)('CHOOSE_USER_LEVEL_TITLE'), true, [okButton], true, [], [{
                      title: 'ERGO Stufe wählen',
                      onChange: this.setUserRank,
                      value: this.state.userRank,
                      classes: {
                        root: _ErgoTopLevelView["default"].select
                      },
                      inputProps: {},
                      options: [{
                        value: 0,
                        text: 'Keine Stufe wählen'
                      }, {
                        value: 1,
                        text: 'Stufe 1'
                      }, {
                        value: 2,
                        text: 'Stufe 2 - Leitender Repräsentant'
                      }, {
                        value: 3,
                        text: 'Stufe 3 - Hauptrepräsentant'
                      }, {
                        value: 4,
                        text: 'Stufe 4 - Chefrepräsentant'
                      }, {
                        value: 5,
                        text: 'Stufe 5 - Direktionsrepräsentant der Stufe 5'
                      }, {
                        value: 6,
                        text: 'Stufe 6 - Direktionsrepräsentant der Stufe 6'
                      }]
                    }]);
                  }

                  levelTarget = this.getLevelTarget();

                  if (levelTarget) {
                    sum = this.getSummedStructureUnitsForTarget(levelTarget);
                    this.setState({
                      structureUnitsForLevel: sum
                    });
                  }
                }

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      this.setRingWidths();
      /*
      if (this.props.keyword === TARGET_KEYWORDS.MY_TARGETS) {
        const userTargets = this.state.data[DATA_STORE_PATHS.ERGO_USER_TARGETS]
        const prevUserTargets = prevState.data[DATA_STORE_PATHS.ERGO_USER_TARGETS]
         if (userTargets && prevUserTargets) {
          const index = userTargets.findIndex(target => target.type === TARGET_TYPES.LEVEL)
          const index2 = prevUserTargets.findIndex(target => target.type === TARGET_TYPES.LEVEL)
           if (index > -1 && index2 > -1) {
            if (userTargets[index] !== prevUserTargets[index2]) {
              this.updateUserData(index)
            }
          }
        }
      }
      */

      if (prevState.data[_DataStore.DATA_STORE_PATHS.ERGO_STRUCTURE_TARGETS] !== this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_STRUCTURE_TARGETS]) {
        this.setRingWidths();
      }

      if (prevState.data[_DataStore.DATA_STORE_PATHS.ERGO_ACTIVATED] !== this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_ACTIVATED]) {
        this.getStructureData();
      }

      if (prevState.data[_DataStore.DATA_STORE_PATHS.ERGO_SUMMED_STRUCTURE_UNITS] !== this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_SUMMED_STRUCTURE_UNITS]) {
        this.getSummedStructureUnitsForCurrentMonth();

        if (this.props.keyword === TARGET_KEYWORDS.MY_TARGETS) {
          var _target2 = this.getLevelTarget();

          if (_target2) {
            var sum = this.getSummedStructureUnitsForTarget(_target2);
            this.setState({
              structureUnitsForLevel: sum
            });
          }
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.countingTimer);
    }
  }, {
    key: "getLevelTarget",
    value: function getLevelTarget() {
      var targets = this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_USER_TARGETS] || [];
      var index = targets.findIndex(function (target) {
        return target.type === TARGET_TYPES.LEVEL;
      });

      if (index > -1) {
        return targets[index];
      } else {
        return null;
      }
    }
  }, {
    key: "renderForTarget",
    value: function renderForTarget(content, targets) {
      var _this3 = this;

      if (content) {
        if (content.background) {
          var backgroundImage = null;

          if (_DeviceInfoHelper["default"].isBrowser()) {
            backgroundImage = content.background;
          } else {
            backgroundImage = "".concat(this.state.filePath).concat(content.background);
          }

          var subtitle = content.subtitle ? content.subtitle : null;
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _ErgoTopLevelView["default"].imageContainerNoShield
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _ErgoTopLevelView["default"].targetShieldBackgroundBottomOverlay
          }), /*#__PURE__*/_react["default"].createElement("div", {
            className: _ErgoTopLevelView["default"].imageText
          }, subtitle), /*#__PURE__*/_react["default"].createElement(_Image["default"], {
            alt: "shield background image",
            id: STATIC_IMAGE_ID,
            className: _ErgoTopLevelView["default"].targetShieldBackground,
            src: backgroundImage
          }));
        } else {
          if (targets.length > 0 && this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_ACTIVATED] === true) {
            return targets.map(function (targetInfo, index) {
              var backgroundImage = null;

              if (targetInfo && targetInfo.background) {
                backgroundImage = targetInfo.background;
              }

              return /*#__PURE__*/_react["default"].createElement("div", {
                key: "".concat(IMAGE_ID).concat(index),
                id: "".concat(IMAGE_ID).concat(index),
                className: _ErgoTopLevelView["default"].imageContainer,
                style: _this3.state.targetIndex === index ? {
                  opacity: 1
                } : {
                  opacity: 0
                }
              }, /*#__PURE__*/_react["default"].createElement("div", {
                className: _ErgoTopLevelView["default"].targetShieldBackgroundTopOverlay
              }), /*#__PURE__*/_react["default"].createElement("div", {
                className: _ErgoTopLevelView["default"].targetShieldBackgroundBottomOverlay
              }), backgroundImage && /*#__PURE__*/_react["default"].createElement("img", {
                className: _ErgoTopLevelView["default"].targetShieldBackground,
                src: backgroundImage
              }));
            });
          } else {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: "placeholder",
              id: "placeholder",
              className: _ErgoTopLevelView["default"].imageContainer,
              style: {
                opacity: 1
              }
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: _ErgoTopLevelView["default"].targetShieldBackgroundTopOverlay
            }), /*#__PURE__*/_react["default"].createElement("div", {
              className: _ErgoTopLevelView["default"].targetShieldBackgroundBottomOverlay
            }), /*#__PURE__*/_react["default"].createElement("img", {
              className: _ErgoTopLevelView["default"].targetShieldBackground,
              src: _data.MONTHLY_BACKGROUND
            }));
          }
        }
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      console.log('targetshield render');
      var className = _ErgoTopLevelView["default"].shieldContainer;

      var content = _KESI2Helper["default"].getContentById(this.props.currentId);

      var currentTargetsToShow = this.getTargets();
      var myTargetValue = 0;
      var structureTargetValue = 0;

      if (currentTargetsToShow.length > 0) {
        currentTargetsToShow[0].conditions.forEach(function (condition) {
          if (condition.type === _ErgoTargetChooser.STRUCTURE_TARGET_TYPES.OWN) {
            myTargetValue = condition.value;
          } else if (condition.type === _ErgoTargetChooser.STRUCTURE_TARGET_TYPES.OTHERS) {
            structureTargetValue = condition.value;
          }
        });
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: className
      }, currentTargetsToShow.length > 0 && /*#__PURE__*/_react["default"].createElement(_ErgoUnitsAdder["default"], {
        open: this.state.showAddUnitsDialog,
        onAdd: this.addUnits,
        onReset: this.resetUnits,
        targetContracts: currentTargetsToShow[this.state.targetIndex].contracts || [],
        onClose: this.showAddUnitsDialog
      }), /*#__PURE__*/_react["default"].createElement(_ErgoTargetChooser["default"], {
        open: this.state.showAddTargetDialog,
        onChoose: this.addTarget,
        keyword: this.props.keyword,
        onClose: this.showAddTargetDialog,
        currentUnits: {
          structure: structureTargetValue,
          own: myTargetValue
        }
      }), this.renderForTarget(content, currentTargetsToShow), this.state.data[_DataStore.DATA_STORE_PATHS.ERGO_ACTIVATED] === true && currentTargetsToShow.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErgoTopLevelView["default"].riskRingContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErgoTopLevelView["default"].infoContainer
      }, !content.background && /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErgoTopLevelView["default"].targetType
      }, currentTargetsToShow && currentTargetsToShow.length > 0 && currentTargetsToShow[this.state.targetIndex] && currentTargetsToShow[this.state.targetIndex].name ? currentTargetsToShow[this.state.targetIndex].name : null), this.props.keyword === TARGET_KEYWORDS.MY_TARGETS && currentTargetsToShow.length > 0 && currentTargetsToShow[this.state.targetIndex] && currentTargetsToShow[this.state.targetIndex].type === TARGET_TYPES.OTHER ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErgoTopLevelView["default"].trash
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "trash",
        onClick: function onClick() {
          _this4.removeTarget(currentTargetsToShow[_this4.state.targetIndex]);
        }
      })) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErgoTopLevelView["default"].dotContainer
      }, currentTargetsToShow.length > 1 && currentTargetsToShow.map(function (region, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: "dot_".concat(index),
          onClick: function onClick() {
            _this4.setState({
              targetIndex: index
            });
          },
          className: _this4.state.targetIndex === index ? _ErgoTopLevelView["default"].activeDot : _ErgoTopLevelView["default"].dot
        });
      })), /*#__PURE__*/_react["default"].createElement(_reactSwipeableViews["default"], {
        index: this.state.targetIndex,
        className: _ErgoTopLevelView["default"].riskRingSwipe,
        springConfig: {
          duration: '1s',
          easeFunction: 'cubic-bezier(0.15, 0.3, 0.25, 1)',
          delay: '0s'
        },
        onChangeIndex: function onChangeIndex(index, lastIndex) {
          _this4.onChangeIndex(index, currentTargetsToShow);
        },
        onSwitching: function onSwitching(index, type) {
          _this4.onSwitching(index);
        },
        slideStyle: {
          overflow: 'visible',
          margin: '0 10%',
          width: '80%'
        },
        resistance: true,
        onTransitionEnd: function onTransitionEnd() {
          return _this4.onTransitionEnd(currentTargetsToShow[_this4.state.targetIndex]);
        }
      }, this.renderTarget(content, currentTargetsToShow)))));
    }
  }]);
  return TargetShield;
}(_DataStoreComponent2["default"]);

TargetShield.propTypes = {
  currentId: _propTypes["default"].string,
  pathArray: _propTypes["default"].array,
  goToNextPage: _propTypes["default"].func,
  showSettingsDialog: _propTypes["default"].func
};
TargetShield.defaultProps = {};
var _default = TargetShield;
exports["default"] = _default;